import Index from './index.vue'
import List from './components/List.vue'
import Profile from './view/Profile.vue'
import Home from './view/Home.vue'

export default [
  {
    path: '/task',
    name: 'task',
    component: Index,
    title: 'Task',
    redirect: { name: 'task-home' },
    children: [
      {
        path: 'list',
        name: 'task-list',
        component: List,
      },
      {
        path: 'profile/:id',
        name: 'task-profile',
        component: Profile,
      },
      {
        path: 'home',
        name: 'task-home',
        component: Home,
      },
    ],
  },
]
